import React from "react";
import { Container, Box } from "@mui/material";

import NavBarLandingPage from "../pages/NavBarLandingPage";
import HeroSection from "./HeroSection";
import HomeSectionTwo from "./HomeSectionTwo";
import FeatureSection from "./FeatureSection";
import CreateYourOwnCloud from "./CreateYourOwnCloud";
import HomeTestimonial from "./HomeTestimonial";
import TiredOfTheOrdinary from "./TiredOfTheOrdinary";
import FooterLandingpage from "../pages/FooterLandingpage";



function HomePage() {

  return (
    <>
      <Box>
        <NavBarLandingPage />
      </Box>
      <Container maxWidth={false} sx={{ padding: { sm: '0 30px' }, }} >

        <HeroSection />
        <HomeSectionTwo />
        <FeatureSection />

        {/* <MegaConnect />
      <FeaturesYouNeed />
      <GetOneDemandApps /> */}
        <CreateYourOwnCloud />
        <HomeTestimonial />
        {/* <HomeFAQ /> */}
        <TiredOfTheOrdinary />

      </Container>
      {/* <Box> */}
      <FooterLandingpage />
      {/* </Box> */}
    </>
  );
}

export default HomePage;
